function escapeCSVValue(value) {
  if (value === undefined || value === null) return '""';
  return '"' + String(value).replace(/"/g, '""') + '"';
}

export function convertToCSV(objArray, columns) {
  var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  var str = '';

  for (var i = 0; i < array.length; i++) {
    // Use a fixed column order so missing/undefined values don't shift cells
    var keys = columns || Object.keys(array[i]);
    str += keys.map(key => escapeCSVValue(array[i][key])).join(',') + '\r\n';
  }

  return str;
}

export function exportCSVFile(headers, items, fileTitle) {
  var rows = headers ? [headers, ...items] : items;
  var csv = convertToCSV(rows, headers ? Object.keys(headers) : null);
  const BOM = '﻿';
  var exportedFilename = fileTitle + '.csv' || 'export.csv';

  var blob = new Blob([BOM + csv], { type: 'text/csv; charset=UTF-8' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilename);
  } else {
    var link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', exportedFilename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
